import {
  AGENT_ROLES,
  SUBSCRIPTIONS_STATUSES,
  SUBSCRIPTIONS_STATUSES_ENUM,
} from '@constants';

const ACCEPTABLE_SUBSCRIPTION_AGENT_ROLES = [
  AGENT_ROLES.isCustomerSuccessCoordinator,
  AGENT_ROLES.isCustomerSuccessManager,
  AGENT_ROLES.isCustomerSuccessTeamLead,
];

const SUBSCRIPTION_STATUSES_OPTIONS = Object.values(
  SUBSCRIPTIONS_STATUSES_ENUM
).map((value) => ({
  text: SUBSCRIPTIONS_STATUSES[value],
  value,
}));

const SUBSCRIPTION_HISTORY_CHANGES_DEFAULT_PAGE_SIZE = 500;

export {
  ACCEPTABLE_SUBSCRIPTION_AGENT_ROLES,
  SUBSCRIPTION_STATUSES_OPTIONS,
  SUBSCRIPTION_HISTORY_CHANGES_DEFAULT_PAGE_SIZE,
};
